module.exports = __webpack_public_path__ + "static/bg-about-81f9e0d2885c758bff6b139a87618b09.jpg";